import React , {Component} from 'react';
//import ClassImg from '../../assets/images/yoga.png';
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/tour/';

export default class ClassesList extends Component {
    // constructor(){
    //     super()
    // }

    TourImage = (img)=>{

        //  alert(img)
        let result = img.slice(0, img.indexOf(','))
        return img_path+result;
  
      }
  
      AddSpecialChar = (str) => {
        if (str !== '' && str !== undefined && str !== null)
            return str.replace(/pnk_Amp/g, "&");
    }


    render(){
        return(
            <div>
            <div className="container-fluid">
            <div className="classes-list-main-div">
            <div className="row">
            <div className="col-md-12 col-lg-12">
            <div className="orders-list-seperation-line"></div>
            </div>
            <div className="col-md-12 col-lg-12"> 
            <div className="row" style={{marginLeft:'0'}}>
            <div className="" style={{marginTop:'-5px' , cursor:'pointer'}} onClick={()=>this.props.HandleRouting('travel')}>
            <h4>Upcoming Tours</h4>
            </div>
           
            <div className="orders-head-line display-none"></div>
            <p class="display-none" style={{cursor:'pointer'}} onClick={()=>this.props.HandleRouting('travel')} >View all</p>
            <i class="fa fa-arrow-right orders-head-arrow" style={{cursor:'pointer'}} aria-hidden="true" onClick={()=>this.props.HandleRouting('travel')}></i>
            </div>
            </div>
            <div class="event-list-mobile classes-list">

            {  this.props.upcomingToursList.length>0 ?

                this.props.upcomingToursList.map((items,i)=>

            <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12" key={i}
            style={{cursor:'pointer'}} 
            onClick={()=>this.props.HandleRouting(`tour-details/${items._id}`)}
            >
            <div class="row">
            <div class="col-6 col-xs-6 col-sm-6">
            <div className="event-image">
            <img src={this.TourImage(items.tour_image)} alt="loading...."/>
            </div>
            </div>

            <div class="col-6 col-xs-6 col-sm-6">
            <div className="event-date">
            <h5>{this.AddSpecialChar(items.tour_name)}</h5>
            <p>{this.AddSpecialChar(items.tour_theme)}</p>
            </div>
            </div>
            { i<this.props.upcomingToursList.length-1 ?
                <div class="col-12">
                <div className="seperation-line"></div>
                </div>
                :''}
            
            </div>
            </div>
                )
            :''}
           
            
           
           
            </div>
            <div className="class-list-desktop col-md-12 col-lg-12">
            <div className="classes-list">
            <div className="row">
           {  this.props.upcomingToursList.length>0 ?

            this.props.upcomingToursList.map((items,i)=>
            

            <div className="col-sm-6 col-md-4 col-lg-4" key={i} style={{cursor:'pointer'}} 
            onClick={()=>this.props.HandleRouting(`tour-details/${items._id}`)}>
            <div className="classes-img">
            <div style={{height:'200px'}}>
            <img src={this.TourImage(items.tour_image)} alt="loading..."/>
            </div>
            <div className="classes-details">
            <h5>{this.AddSpecialChar(items.tour_name)}</h5>
            <p>{this.AddSpecialChar(items.tour_theme)}</p>
            </div>
            </div>
            </div>
            )

            : ''


           }
           
            </div>
            </div>
            </div>
            <div className="col-md-12 col-lg-12">
            <div className="seperation-line"></div>
            </div>

            
            
            </div>
            
            </div>
            
            </div>
            </div>
        )
    }
}